<template>
  <div  :style='{width: panelWidth}' >
    <!--
    <table width='100%' class='table' :height="panelHeight"  v-if='data && data.length'>
      <tr>
        <th width='16%' class='colTitle'>{{ $t(label) }}</th>
        <th width='14%' class='colTitle'>{{ $t("Exposure") }}</th>
        <th width='14%' class='colTitle'>{{ $t("Hedged Amt") }}</th>
        <th width='14%' class='colTitle'>{{ $t("Net Amt") }}</th>
        <th width='14%' class='colTitle'>{{ $t("P&L") }}</th>
        <th width='14%' class='colTitle'>{{ $t("Hedge P&L") }}</th>
        <th width='14%' class='colTitle'>{{ $t("Net P&L") }}</th>
      </tr>
      <tr v-for='(inst, index) in data' :key='inst.currencyList' v-if='index < count'>
        <td width='16%' class='rowTitle'>{{ inst.label }}</td>
        <td width='14%' class='rowData' :class='inst.exposure >= 0 ? "positive" : "negative"' >{{ inst.exposure | formatAmount }}</td>
        <td width='14%' class='rowData' :class='inst.hedgedAmount >= 0 ? "positive" : "negative"' >{{ inst.hedgedAmount | formatAmount }}</td>
        <td width='14%' class='rowData' :class='inst.deltaHedge >= 0 ? "positive" : "negative"' >{{ inst.deltaHedge | formatAmount }}</td>
        <td width='14%' class='rowData' :class='inst.profitAndLoss >= 0 ? "positive" : "negative"'>{{ inst.profitAndLoss | formatAmount }}</td>
        <td width='14%' class='rowData' :class='inst.profitLost >= 0 ? "positive" : "negative"' >{{ inst.profitLost | formatAmount }}</td>
        <td width='14%' class='rowData' :class='inst.delta >= 0 ? "positive" : "negative"'>{{ inst.delta | formatAmount }}</td>
      </tr>
    </table>
    -->
    <el-table
      class='riskTable'
      :data="data"
      :height="panelHeight"
      :cell-class-name = "() => 'lu-click'"
      fit
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.label)'
      style="width: 100%;"
    >
      <el-table-column :label="$t(label)" sortable prop='label' align="left" />
      <el-table-column :label="$t('Exposure')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="left" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Hedged Amt')" sortable prop='hedgedAmount' :sort-method='(a,b) => sortFloat(a,b,"hedgedAmount")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.hedgedAmount >= 0  ? "positive" : "negative"'>{{ scope.row.hedgedAmount | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Net Amt')" sortable prop='deltaHedge' :sort-method='(a,b) => sortFloat(a,b,"deltaHedge")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.deltaHedge >= 0  ? "positive" : "negative"'>{{ scope.row.deltaHedge | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('P&L')" sortable prop='profitAndLoss' :sort-method='(a,b) => sortFloat(a,b,"profitAndLoss")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.profitAndLoss >= 0  ? "positive" : "negative"'>{{ scope.row.profitAndLoss | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Hedge P&L')" sortable prop='profitLost' :sort-method='(a,b) => sortFloat(a,b,"profitLost")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.profitLost >= 0  ? "positive" : "negative"'>{{ scope.row.profitLost | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Net P&L')" sortable prop='delta' :sort-method='(a,b) => sortFloat(a,b,"delta")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.delta >= 0  ? "positive" : "negative"'>{{ scope.row.delta | formatAmount }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import { mapState } from 'vuex'
import monitoringMixin from './mixins'

export default {
  name: 'HedgeArray',
  props: [ 'data', 'label', 'panel' ],
  mixins: [ monitoringMixin ],
  computed: {
    ...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping }),
    isSymbolGrpKey: function () {
      return this.groupKeys[this.panel.options.groupKey] === "symbol"
    }
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatPercent: function (value) {
      return value + ' %'
    }
  },
  methods: {
    getDetail: function (label) {
      let curLabel = this.isSymbolGrpKey ? 'symbol' : 'currency'
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': curLabel, 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: curLabel.toLowerCase(), value: label, params: params, show: true})
    }
  }
}
</script>

<style scoped>

</style>